import { ref } from 'vue'

type ConfirmOptions = {
  message: string
  confirmText?: string
  cancelText?: string
}

const isVisible = ref(false)
const message = ref('')
const confirmText = ref('OK')
const cancelText = ref('Abbrechen')

let resolveFn: (result: boolean) => void

export function useConfirmDialog() {
  function open(options: ConfirmOptions): Promise<boolean> {
    message.value = options.message
    confirmText.value = options.confirmText || 'OK'
    cancelText.value = options.cancelText || 'Abbrechen'
    isVisible.value = true

    return new Promise((resolve) => {
      resolveFn = resolve
    })
  }

  function confirm() {
    isVisible.value = false
    resolveFn(true)
  }

  function cancel() {
    isVisible.value = false
    resolveFn(false)
  }

  return {
    isVisible,
    message,
    confirmText,
    cancelText,
    open,
    confirm,
    cancel
  }
}